import React from 'react'
import Image from 'material-ui-image'

const Itind_EN = () => {
    return (
        <section id="about1">
            <div className="row">
                <h2>The iTind Treatment</h2>
                <p className="white">
                    iTind is a temporarily implanted nitinol device which delivers rapid relief from BPH symptoms
                    through a minimally invasive treatment.<br/>
                    The iTind is inserted in a simple and straightforward procedure. The device is placed into the
                    prostate where it expands and exerts localized ischemic pressure on the tissue. This pressure aims
                    to reshape the tissue of the prostatic urethra and the bladder neck, creating three longitudinal
                    channels through which urine can flow.<br/>
                    Patients are able to return home during the 5-7 day treatment. After the implantation period of 5-7
                    days, the device is completely removed.
                    <h2>How Does iTind Work?</h2>
                    <img
                        src="https://cdn.mannheim-urology.com/photos/itind.png"
                        alt="iTind Method"
                    />
                    The iTind is placed in the prostatic urethra in a narrow, folded configuration under vision.
                    <br/>
                    During the 5-7 day treatment, the device expands and exerts continuous pressure at the 5, 7 and 12
                    o’clock positions to remodel the prostatic urethra and the bladder neck.
                    <br/>
                    After 5-7 days the device is completely removed, aiming to leave a wider opening through which urine
                    can flow, and to relieve the symptoms of BPH.
                    <br/>
                    <h2>Clinical Evidence</h2>
                    Clinical data demonstrate that the first generation TIND boasts a durability of three years, and
                    powerful efficacy at 36 months is also demonstrated by the second-generation and commercially
                    available iTind.
                    <br/>
                    <ol>
                        <li>Rapid and effective relief from BPH symptoms. </li>
                        <li>Lower risk profile than more invasive procedures.</li>
                        <li>Routinely catheter free procedure.</li>
                        <li>Preserves sexual and ejaculatory function.</li>
                        <li>No permanent implant resulting from the procedure.</li>
                        <li>Straightforward procedure.</li>
                    </ol>
                </p>
            </div>
        </section>
    )
}

export default Itind_EN



// WEBPACK FOOTER //
// ./src/Components/Itind/Itind_EN.js